export const FEATURES = [
  {
    title: "Save up to 100+ hours a year",
    description: "Stop wasting hours qualifying irrelevant cold meeting requests. AddMeetings uses intent-based AI to automatically filter and prioritize — so you only meet with the right people.",
    icon: 'schedule', // Material icon name: clock
  },
  {
    title: "Skip Sharing Scheduling Links",
    description: "No more juggling calendar tools or sending links back and forth.  Just say, “Meet me on AddMeetings,” and let people send meeting requests that get instantly screened and sorted based on your preferences.",
    icon: 'payments', // Material icon name for money
  },
  {
    title: "Qualify Smarter, Not Manually",
    description: "Forget the endless email threads, messages, and manual vetting. AddMeetings pre-screens requests using your rules and AI scoring, so you can accept qualified meetings in one click — right from your inbox.",
    icon: 'potted_plant', // Material icon name for plant
  },
];

export const HOW_IT_WORKS_STEPS = [
  {
    number: '01',
    title: 'Share Your Meeting Intent',
    content: 'Sign up for free and tell AddMeetings what kinds of meetings you’re open to. Business needs, topics, or industries that matter to you. Our intent-based AI uses this to understand your preferences from day one.',
    image: 'https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg' // Image of a person sharing business needs
  },
  {
    number: '02',
    title: 'Connect Your Calendar',
    content: 'Securely sync your calendar so qualified meetings can be scheduled automatically. AddMeetings works with Google Calendar currently, keeping your schedule organized and up to date.',
    image: 'https://images.pexels.com/photos/3184638/pexels-photo-3184638.jpeg' // Image of financial planning or fee setup
  },
  {
    number: '03',
    title: 'Say “Meet Me on AddMeetings”',
    content: 'Skip sharing links or qualifying requests manually. Every meeting request is automatically screened based on your intent and preferences — only the most relevant ones reach your inbox, and the rest get filtered out.',
    image: 'https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg' // Image of a person reviewing documents or requests
  },
  {
    number: '04',
    title: 'Accept or Reject Straight from Your Inbox',
    content: 'AddMeetings filters and scores every request so only the most relevant, high-value ones reach your inbox and calendar. You stay in control and can accept or reject qualified meetings in one click right from your inbox.',
    image: 'https://images.pexels.com/photos/3184298/pexels-photo-3184298.jpeg' // Image of a person accepting or scheduling a meeting
  },
  {
    number: '05',
    title: 'Have the Right Conversations',
    content: 'AddMeetings ensures every meeting that reaches you is relevant, valuable, and aligned with your goals. Spend your time on conversations that truly move your business forward',
    image: 'https://images.pexels.com/photos/3184339/pexels-photo-3184339.jpeg' // Image of a virtual meeting or call
  }
] as const;
